import loginReducer from './reducers';
import * as allLoginActions from './actions';

export { default as loginOperations } from './operations';
export { default as loginTypes } from './types';
export const loginActions = allLoginActions;
export default loginReducer;
